<template>
  <div>
  
    <CCard style="margin-top: 20px">
        <CCol xs="12" lg="12" style="margin-top: 20px">
        
            <CTabs variant="pills">
              <CTab title="Tetris claimed Points" active>
                <hr>
                <Tetrisclaimed></Tetrisclaimed>
              </CTab>
              <CTab title="Tetris unclaimed Points">
                <hr>
              <Tetrisunclaimed></Tetrisunclaimed>
              </CTab>
              <CTab title="Tetris Points Entry">
                <hr>
              <TetrispoinEntry></TetrispoinEntry>
              </CTab>

              <CTab title="Tetris Daily Updates">
                <hr>
              <TetrisDailyLimit></TetrisDailyLimit>
              </CTab>
             
            </CTabs>
        
      </CCol>
    
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import Tetrisclaimed from "./tetrisclaimed.vue"
import Tetrisunclaimed from "./tetrisunclaimed.vue"
import TetrispoinEntry from "./tetrispoinEntry.vue"
import TetrisDailyLimit from "./tetrisDailyLimit.vue"

export default {
  components: {
    Tetrisclaimed,
    Tetrisunclaimed,
    TetrispoinEntry,
    TetrisDailyLimit
    
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
   
     
    };
  },
  watch: {
   
  },
  methods: {
    
    // sendmsg(){}
  },
  created() {

  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>